/**
  * @class meleMap_square
  * @description
  *
  * # Purpose
  * Implaments square shape
  *
  * # Use
  *
  * # Implementation notes
  *
  */

import meleMap_shape from '../meleMap_shape.js'
const melemap_lib = require('../meleMap_lib.js')

export default class meleMap_square extends meleMap_shape {
  static shape() { return 'S' }

  _getOpositePoint(point1, point2) {
    point1 = Array.isArray(point1) ? point1 : [point1.lat, point1.lng]
    point2 = Array.isArray(point2) ? point2 : [point2.lat, point2.lng]
    point2 = [point1[0], point2[1]]
    const lng_distance = L.latLng(point1).distanceTo(point2)
    point2[0] = point1[0] - lng_distance/111000
    return point2
  }

  redrawShape() {
    if(this._points.length<2) { return this.deleteShape() }

    const point1 = this._points[0]
    const point2 = this._getOpositePoint(point1, this._points[1])
    const points = [point1, point2]
    if(this._shape) {
      this._shape.setBounds(points)
    }else {
      this._shape = L.rectangle(points, { pane: this._props.pane || melemap_lib.DEFAULT_PANE }).addTo(this._map)
    }

    this.configureShape()
  }

  calculateCenter() {
    if(this._points.length<2 || !this._shape) return(this._center = null)
    const point1 = this._points[0]
    const point2 = this._getOpositePoint(point1, this._points[1])
    return this._center = melemap_lib.intermediatePoint(point1, point2, 0.5)
  }

  shape() {
    const points = _.cloneDeep(this._points)
    if(points.length>=2) {
      points[1] = this._getOpositePoint(points[0], points[1])
    }
    return 'S,'+this._points.slice(0, 2).map(point=>melemap_lib.point2geohash(point)).join(',')
  }

  addPoint(point) {
    if(this._points.length>=2) { this._points=[] }
    this._points.push(point)
    delete this._center
    this.redrawShape()
    this.redrawMarker()

    // prepare guiding square if we have just one point
    if(this._points.length==1) {
      this._guide = L.rectangle([this._points[0], this._points[0]], { pane: melemap_lib.DRAW_PANE }).addTo(this._map)
      this._guide._path.setAttribute('marker', 'guide')
    }else if(this._guide) {
      this._map.removeLayer(this._guide)
      this._guide = null
    }
  }

  guide(point) {
    if(this._guide) {
      const last_point = this._points[this._points.length-1]
      if(!point) point = last_point
      point = this._getOpositePoint(last_point, point)
      this._guide.setBounds([last_point, point])
    }
  }
} // class meleMap_square
